export class DateType {
    private date: Date;
    constructor(date: string) {
        if (date.toString().indexOf('/Date') > -1)
            this.date = new Date(parseInt(date.toString().substr(6)));
        else
            this.date = new Date(date);
    }

    toLocalTimeZone() {
        return this.date;
    }

    toGMTTimeZone() {
        this.date.setTime(this.date.getTime() - this.date.getTimezoneOffset() * 60 * 1000);
        return this.date;
    }
}

export class DateUtil {
    public static defaultNAtranslateValue = "N/A";
    public static ConvertToLocalTimeZone(date: string | Date) {     
        if (date && date != "/Date(-62135596800000)/" && date != "/Date(-62135578800000)/")
            return new DateType(date.toString()).toLocalTimeZone();
        else
            return this.defaultNAtranslateValue
    }
}